import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Coin from "./Coin";

const ZoneCard = ({ title, coins, onBookNow, isLast = false }) => {
  const navigate = useNavigate();
  return (
    <div className="mb-8 w-full">
      {/* Activity Title */}
      <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-4 leading-tight">
        {title}
      </h2>

      {/* Coins Badge */}
      <div className="flex items-center mb-6 justify-center lg:justify-start">
        <div className="flex items-center space-x-2">
          <Coin value={coins} />
        </div>
      </div>

      {/* Book Now Button */}
      {isLast && (
        <div className="flex justify-center lg:justify-start">
          <button
            onClick={() => {
              navigate("/book");
            }}
            className="bg-[rgb(3,234,46)] hover:bg-green-600 text-white font-bold py-2 px-6 sm:py-3 sm:px-8 rounded-lg transition-all duration-300 text-xs sm:text-sm uppercase tracking-wider shadow-lg hover:shadow-xl transform hover:scale-105 mt-4"
          >
            BOOK NOW
          </button>
        </div>
      )}
    </div>
  );
};

const ReusableZoneSection = ({
  backgroundImage,
  activities = [],
  images = [],
  onBookNow = () => {},
  className = "",
}) => {
  return (
    <div
      className={`w-full min-h-screen relative overflow-hidden ${className}`}
    >
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex items-center py-8 sm:py-12">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left Side - Zone Cards */}
            <div className="space-y-0 flex flex-col items-center lg:items-start text-center lg:text-left order-2 lg:order-1">
              {activities.map((activity, index) => (
                <ZoneCard
                  key={activity.id || index}
                  title={activity.title}
                  coins={activity.coins}
                  onBookNow={() => onBookNow(activity.id || index)}
                  isLast={index === activities.length - 1}
                />
              ))}
            </div>

            {/* Right Side - Images */}
            <div className="space-y-4 sm:space-y-6 order-1 lg:order-2">
              {images.map((image, index) => (
                <div key={index} className="relative">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-32 sm:h-40 md:h-48 lg:h-56 object-cover rounded-xl shadow-2xl border-2 border-white/20 transition-transform duration-300 hover:scale-105"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReusableZoneSection;
